import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { sanitize } from '@americanexpress/consumer-travel-base';
import styles from './Steps.scss';

const StepComponent = ({ number, details }) => (
  <>
    <div className="pad-2-b" id={`step-${number}`}>
      <div className="text-align-center">
        <img
          className={styles.image}
          src={details.imageURL}
          alt=""
        />
      </div>
      <div className="flex flex-justify-center">
        <div className={clsx(styles.badge, 'color-graphic-brand-logo-blue-box-text dls-bright-blue-bg text-align-center font-weight-bold')}>
          {number}
        </div>
      </div>
    </div>
    <div
      id={`step-${number}-body`}
      className="body-1 pad-2-b text-align-center"
      /* eslint-disable-next-line react/no-danger -- content from oneCMS */
      dangerouslySetInnerHTML={{ __html: sanitize(details.description, { html: true }) }}
    />
  </>
);

StepComponent.propTypes = {
  number: PropTypes.number.isRequired,
  details: PropTypes.shape({
    imageURL: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default StepComponent;
